import { render, staticRenderFns } from "./choose-distribution.vue?vue&type=template&id=950eacd2&scoped=true"
import script from "./choose-distribution.vue?vue&type=script&lang=ts"
export * from "./choose-distribution.vue?vue&type=script&lang=ts"
import style0 from "./choose-distribution.vue?vue&type=style&index=0&id=950eacd2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950eacd2",
  null
  
)

export default component.exports